export const downloadFileFromURL = (fileURL: string): void => {
  const link = document.createElement('a');
  link.href = fileURL;
  link.click();
};
